/**
 * Strips a trailing ".00" / ",00" from price elements (product price and
 * cart drawer subtotal), keeping the price display in sync with Liquid's
 * `money_without_trailing_zeros` filter even after JS updates the DOM.
 *
 * Works independently of theme.js — watches the price element(s) with a
 * MutationObserver, so it re-applies the trim every time the text changes,
 * no matter what triggered the update (variant swap, mini cart open, AJAX
 * add to cart, quantity change, etc).
 */
(function () {
  var PRICE_SELECTOR = '[data-product-price]';

  function trimZeros(text) {
    return text
      .replace(/<sup>00<\/sup>/, '')   // superscript cents markup, if theme uses it
      .replace(/([.,])00(?=\D|$)/, ''); // plain ".00" / ",00" before a non-digit or end of string
  }

  function stripTrailingZeros(el) {
    var current = el.textContent;
    var trimmed = trimZeros(current);

    if (trimmed !== current) {
      el.textContent = trimmed;
    }
  }

  function observePriceElement(el) {
    if (el.dataset.priceZerosObserved) return; // avoid double-binding
    el.dataset.priceZerosObserved = 'true';

    stripTrailingZeros(el); // handle price already on the page (page load)

    var observer = new MutationObserver(function () {
      observer.disconnect();
      stripTrailingZeros(el);
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });

    observer.observe(el, { childList: true, characterData: true, subtree: true });
  }

  function initExisting() {
    document.querySelectorAll(PRICE_SELECTOR).forEach(observePriceElement);
  }

  // Catch price elements that get added later — quick view modals,
  // AJAX-loaded sections, product cards swapped in via infinite scroll, etc.
  function watchForNewPriceElements() {
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches(PRICE_SELECTOR)) {
            observePriceElement(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll(PRICE_SELECTOR).forEach(observePriceElement);
          }
        });
      });
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initExisting();
      watchForNewPriceElements();
    });
  } else {
    initExisting();
    watchForNewPriceElements();
  }
})();